import React from "react";
import { Paper } from "@mui/material";

export default function (props) {
  const { children, style } = props;
  return (
    <Paper elevation={0} sx={style}>
      {children}
    </Paper>
  );
}
